export const msalConfig = {
  auth: {
    clientId: "2364512a-531e-49d1-a7a7-a56814bf19f1",
    authority: "https://login.microsoftonline.com/common/",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};
